import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/config/config-service';
import { TransferMedium } from '../models/transfer-medium.model';

@Injectable({ providedIn: 'root' })
export class TransferMediumService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.configService.getUrlVendorCatalogApi()}/mediums`;
  }

  /**
   * Lädt alle Länder vom Backend.
   */
  fetchTransferMediums(): Observable<TransferMedium[]> {
    return this.http.get<TransferMedium[]>(this.baseUrl);
  }

}